import type { UnknownAction } from '@reduxjs/toolkit';

import { resourceUpserters } from '../core';
import * as actions from './investmentQuotesV2Actions';
import {
  type InvestmentQuotesV2Store,
  type InvestmentQuoteTypeV2,
  mkInvestmentQuotesV2Store,
} from './investmentQuotesV2Types';

function investmentQuotesV2Reducer(
  state: InvestmentQuotesV2Store = mkInvestmentQuotesV2Store(),
  action: UnknownAction,
): InvestmentQuotesV2Store {
  switch (true) {
    case actions.getInvestmentQuotesV2.match(action):
      return state.set('isLoading', true);
    case actions.getInvestmentQuotesV2Success.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getInvestmentQuotesV2Failure.match(action):
      return resourceUpserters.completeWithError<InvestmentQuoteTypeV2>(state, action.payload);
    default:
      return state;
  }
}

export { INVESTMENT_QUOTES_V2_REDUCER_KEY } from './investmentQuotesV2Types';
export default investmentQuotesV2Reducer;
